import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { NavItem, NAV_ITEMS } from '../types/navItem'
import { BOTTOM_NAV_HEIGHT } from '../constants/layout'
import { useAuthStore } from '../stores/authStore'
import { isIOS } from '../utils/platform'

interface BottomNavProps {
  activePath: string
  relative?: boolean
}

const BottomNav: React.FC<BottomNavProps> = ({
  activePath,
  relative = false,
}) => {
  const navigate = useNavigate()
  const { profileImage, loadProfileImage, isAuthenticated } = useAuthStore()

  useEffect(() => {
    if (isAuthenticated) {
      loadProfileImage()
    }
  }, [isAuthenticated, loadProfileImage])

  const handleNavClick = (path: string) => {
    navigate(path)
  }

  // iOS edge-to-edge(하단 SafeArea 해제)에서만 하단 safe-area까지 바 배경을 확장.
  // 패딩을 '그림자 있는 바 자체'에 줘서, 아래방향 그림자가 바 전체 아래(=화면 밖)로 가
  // 크림 safe-area 스트립 위에 안 드리워지게(이음새/그림자 띠 제거).
  const iosEdge = !relative && isIOS()
  return (
    <div
      className={
        relative ? 'relative w-full' : 'fixed bottom-0 left-0 right-0 z-60'
      }
    >
      <div
        className="app-container bg-ivoryKey"
        style={{
          height: `${BOTTOM_NAV_HEIGHT}px`,
          boxShadow: '0px 4px 10px 0px rgba(117, 76, 0, 0.5)',
          ...(iosEdge
            ? {
                boxSizing: 'content-box' as const,
                paddingBottom: 'env(safe-area-inset-bottom)',
              }
            : {}),
        }}
      >
        <div className="w-full h-full flex">
          <div className="w-full flex">
            {NAV_ITEMS.map((item: NavItem) => {
              const isActive = activePath === item.path
              const isMyPage = item.id === 'my'

              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => handleNavClick(item.path)}
                  className={`
                    flex-1
                    flex
                    items-center
                    justify-center
                `}
                >
                  {isMyPage ? (
                    <div
                      data-tutorial={`nav-${item.id}`}
                      className="w-30px h-30px rounded-full overflow-hidden bg-[#F1EBE4]"
                    >
                      <img
                        src={
                          profileImage || '/images/profile-placeholder-icon.png'
                        }
                        alt=""
                        className={`w-full h-full object-cover ${
                          profileImage ? '' : 'opacity-80'
                        }`}
                      />
                    </div>
                  ) : (
                    <img
                      data-tutorial={`nav-${item.id}`}
                      src={isActive ? item.activeIcon : item.inactiveIcon}
                      alt=""
                      className="w-26px h-26px object-contain opacity-80"
                    />
                  )}
                </button>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BottomNav
